const firebaseConfig = {
    apiKey: "AIzaSyD7rF6A3jNPXYJPbji6OclCqA6yF_NE5xg",
    authDomain: "red-onion-mon.firebaseapp.com",
    databaseURL: "https://red-onion-mon.firebaseio.com",
    projectId: "red-onion-mon",
    storageBucket: "red-onion-mon.appspot.com",
    messagingSenderId: "428168871381",
    appId: "1:428168871381:web:a5afdc5204c7e0a8d0915c"
  };

  export default firebaseConfig;